export default {
  CRS: [
    { id: 1, text: 'Clinical Monitoring', name: 'ClinicalMonitoring' },
    { id: 2, text: 'Clinical Quality Management', name: 'ClinicalQualityManagement' },
    { id: 3, text: 'Essential Regulatory Documents', name: 'EssentialRegulatoryDocuments' },
    { id: 4, text: 'Human Subjects Protection', name: 'HumanSubjectsProtection' },
    { id: 5, text: 'Medical Writing', name: 'MedicalWriting' },
    { id: 6, text: 'Protocol Development', name: 'ProtocolDevelopment' },
    { id: 7, text: 'Protocol Deviation Reporting', name: 'ProtocolDeviationReporting' },
    { id: 8, text: 'SAE Reporting', name: 'SAEReporting' },
    { id: 9, text: 'Safety Oversight Committee', name: 'SafetyOversightCommittee' },
    { id: 10, text: 'Study Product Information', name: 'StudyProductInformation' },
    { id: 11, text: 'Teleconference Support', name: 'TeleconferenceSupport' }
  ],
  ServiceRequests: [
    { id: 1, text: 'Clinical Monitoring', name: 'SRClinicalMonitoring' },
    { id: 2, text: 'Clinical Monitoring Report', name: 'ClinicalMonitoringReport' },
    { id: 3, text: 'Clinical Quality Management Services', name: 'ClinicalQualityManagementServices' },
    { id: 4, text: 'Clinical Quality Management Services Report', name: 'ClinicalQualityManagementServicesReport' },
    { id: 5, text: 'CROMS Quality Crosswalk Review', name: 'CROMSQualityCrosswalkReview' },
    { id: 6, text: 'CROMS Quality Crosswalk Review Report', name: 'CROMSQualityCrosswalkReviewReport' },
    { id: 7, text: 'DSMB-SMC Coordination', name: 'DSMB-SMCCoordination' },
    { id: 8, text: 'DSMB-SMC Coordination Report', name: 'DSMB-SMCCoordinationReport' },
    { id: 9, text: 'Essential Regulatory Documents', name: 'SREssentialRegulatoryDocuments' },
    { id: 10, text: 'Essential Regulatory Documents Report', name: 'EssentialRegulatoryDocumentsReport' },
    { id: 11, text: 'Human Subjects Protection', name: 'HumanSubjectsProtection' },
    { id: 12, text: 'Medical Writing', name: 'SRMedicalWriting' },
    { id: 13, text: 'Medical Writing Report', name: 'MedicalWritingReport' },
    { id: 14, text: 'Miscellaneous Services', name: 'MiscellaneousServices' },
    { id: 15, text: 'Miscellaneous Services Report', name: 'MiscellaneousServicesReport' },
    { id: 16, text: 'Report a Protocol Deviation', name: 'ReportaProtocolDeviation' },
    { id: 17, text: 'Protocol Deviation Report', name: 'ProtocolDeviationReport' },
    { id: 18, text: 'Protocol Number Request', name: 'ProtocolNumberRequest' },
    { id: 19, text: 'Teleconference Support', name: 'SRTeleconferenceSupport' },
    { id: 20, text: 'Teleconference Support Report', name: 'TeleconferenceSupportReport' },
    { id: 21, text: 'Training', name: 'SRTraining' },
    { id: 22, text: 'Training Report', name: 'TrainingReport' }
  ]
}
